export class ProbeError extends Error {
    kind;
    cause;
    constructor(kind, message, 
    // `override` required because ES2022 Error declares `cause` natively
    // and tsconfig has `noImplicitOverride: true`.
    cause) {
        super(message);
        this.kind = kind;
        this.cause = cause;
        this.name = 'ProbeError';
    }
}
export class DriverError extends Error {
    kind;
    cause;
    constructor(kind, message, 
    // `override` required because ES2022 Error declares `cause` natively
    // and tsconfig has `noImplicitOverride: true`.
    cause) {
        super(message);
        this.kind = kind;
        this.cause = cause;
        this.name = 'DriverError';
    }
}
//# sourceMappingURL=errors.js.map